const WRITE_METHODS = new Set(["POST", "PUT", "PATCH", "DELETE"]);
const WEB_CLIENT_HEADER = "X-AEL-Client";
const WEB_CLIENT_VALUE = "web";
const INSTALL_FLAG = "__aelWebApiFetchMarkerInstalled";

const KNOWN_BACKEND_API_BASES = [
  process.env.NEXT_PUBLIC_BACKEND_URL_OVERRIDE,
  "http://localhost:3001/api",
  "https://ael-backend-development-402643550069.europe-west3.run.app/api",
  "https://ael-backend-main-402643550069.europe-west3.run.app/api",
].filter(Boolean);

function getRequestUrl(input) {
  if (typeof Request !== "undefined" && input instanceof Request) {
    return input.url;
  }

  if (typeof URL !== "undefined" && input instanceof URL) {
    return input.href;
  }

  return String(input);
}

function getRequestMethod(input, init) {
  if (init?.method) return String(init.method).toUpperCase();
  if (typeof Request !== "undefined" && input instanceof Request) {
    return input.method.toUpperCase();
  }
  return "GET";
}

function isBackendApiUrl(input) {
  try {
    const requestUrl = new URL(getRequestUrl(input), window.location.href);

    return KNOWN_BACKEND_API_BASES.some((base) => {
      const apiBase = new URL(base, window.location.href);
      const basePath = apiBase.pathname.replace(/\/+$/, "");
      return (
        requestUrl.origin === apiBase.origin &&
        (requestUrl.pathname === basePath ||
          requestUrl.pathname.startsWith(`${basePath}/`))
      );
    });
  } catch {
    return false;
  }
}

function addWebClientHeader(input, init) {
  const headers = new Headers(
    typeof Request !== "undefined" && input instanceof Request
      ? input.headers
      : undefined,
  );

  new Headers(init?.headers).forEach((value, name) => {
    headers.set(name, value);
  });
  headers.set(WEB_CLIENT_HEADER, WEB_CLIENT_VALUE);

  return { ...init, headers };
}

export function installWebApiFetchMarker() {
  if (typeof window === "undefined" || window[INSTALL_FLAG]) return;

  const originalFetch = window.fetch.bind(window);

  window.fetch = (input, init) => {
    const isWrite = WRITE_METHODS.has(getRequestMethod(input, init));
    if (!isWrite || !isBackendApiUrl(input)) {
      return originalFetch(input, init);
    }

    return originalFetch(input, addWebClientHeader(input, init));
  };

  window[INSTALL_FLAG] = true;
}
